// Currency Status Enum
export enum CurrencyStatus {
  ACTIVE = "Active",
  INACTIVE = "Inactive",
  PENDING = "Pending"
}

// Symbol Position Enum
export enum SymbolPosition {
  BEFORE = "before",
  AFTER = "after"
}

// Region Setting Interface
export interface RegionSetting {
  id: string;
  name: string;
  code: string;
}

// Currency Status Interface
export interface CurrencyStatusData {
  id: string;
  name: string;
}

// Currency Interface
export interface Currency {
  id: string;
  name: string;
  initial: string;
  regions?: RegionSetting[] | null;
  status?: CurrencyStatusData | null;
  MaxLimit?: number | null;
  minLimit?: number | null;
  emergencyHolidayCommission?: number | null;
  emergencyNightCommission?: number | null;
  regularCommission?: number | null;
  SettingDecimalPlaces?: number | null;
  SettingThousandsSeparator?: string | null;
  SettingDecimalSeparator?: string | null;
  SettingSymbolPosition?: string | null;
  exchangeRate?: number | null;
  isDefault?: boolean | null;
  symbol?: string | null;
  emergencyFee?: number | null;
  platformFee?: number | null;
  transactionFee?: number | null;
  emergencyCommissionRate?: number | null;
  regularCommissionRate?: number | null;
  createdAt: Date;
  updatedAt: Date;
}

// Currency Create DTO
export interface CurrencyCreateDto {
  name: string;
  initial: string;
  regions?: RegionSetting[];
  status?: CurrencyStatusData;
  MaxLimit?: number;
  minLimit?: number;
  emergencyHolidayCommission?: number;
  emergencyNightCommission?: number;
  regularCommission?: number;
  SettingDecimalPlaces?: number;
  SettingThousandsSeparator?: string;
  SettingDecimalSeparator?: string;
  SettingSymbolPosition?: string;
  exchangeRate?: number;
  isDefault?: boolean;
  symbol?: string;
  emergencyFee?: number;
  platformFee?: number;
  transactionFee?: number;
  emergencyCommissionRate?: number;
  regularCommissionRate?: number;
}

// Currency Update DTO
export type CurrencyUpdateDto = Partial<CurrencyCreateDto>

// Bulk Currency Create DTO
export interface BulkCurrencyCreateDto {
  currencies: CurrencyCreateDto[];
}

// Currency Query Parameters
export interface CurrencyQueryParams {
  page?: number;
  limit?: number;
  name?: string;
}

// Currency Response
export interface CurrencyResponse {
  data: Currency[];
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  page: number;
  limit: number;
  totalCount: number;
}

// Currency Action Modal Props
export interface CurrencyActionModalProps {
  isOpen: boolean;
  onClose: () => void;
  currency?: Currency | null;
  mode: "create" | "edit" | "view";
}
